import { render, staticRenderFns } from "./home-pagination-widget.vue?vue&type=template&id=fd3cd198&scoped=true&"
import script from "./home-pagination-widget.vue?vue&type=script&lang=js&"
export * from "./home-pagination-widget.vue?vue&type=script&lang=js&"
import style0 from "./home-pagination-widget.vue?vue&type=style&index=0&id=fd3cd198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3cd198",
  null
  
)

export default component.exports